import Script from 'next/script';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { loadUserPreferences } from '@pflegia/analytics/ui/consent/load-user-preferences';
import getGoogleTagManagerScript from '@pflegia/analytics/ui/scripts/get-google-tag-manager-script';

const loadSegmentConsent = async (setSegmentConsent: Dispatch<SetStateAction<boolean>>) => {
  const consent = await loadUserPreferences();
  setSegmentConsent(consent.customPreferences?.advertising ?? false);
};

export const GoogleTagManagerScript = ({ gtmId, checkConsent }: { gtmId?: string; checkConsent?: boolean }) => {
  const [segmentConsent, setSegmentConsent] = useState<boolean>(false);
  useEffect(() => {
    if (checkConsent) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      loadSegmentConsent(setSegmentConsent);
    }
  }, [checkConsent]);
  const namedGtmId = gtmId ?? process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
  const script = getGoogleTagManagerScript(namedGtmId);
  return (
    namedGtmId && (
      <>
        <Script id='gtm' dangerouslySetInnerHTML={{ __html: script }} strategy='lazyOnload' />
        {segmentConsent && (
          // Must stay 'afterInteractive': with 'lazyOnload' bat.bing.com isn't ready when the funnel submits,
          // so the UET registration conversion is dropped
          // (PFLGTG-2125 already had to revert lazyOnload on Segment/Meta for the same reason).
          <Script src='https://bat.bing.com/bat.js' strategy='afterInteractive' />
        )}
      </>
    )
  );
};
